import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import {sectionType} from '../../utils/VideoRecapUtils';

import VideoRecapHeader from './VideoRecapHeader';
import VideoRecapScene from './VideoRecapScene';
import VideoRecapSoundtrack from './VideoRecapSoundtrack';
import VideoRecapTheme from './VideoRecapTheme';

const i18nPrefix = 'epic.fortnite.idomoo.video';

export default class VideoRecapSection extends React.Component {
  static propTypes = {
    section: PropTypes.object,
    mobile: PropTypes.bool,
    tablet: PropTypes.bool,
    getMessage: PropTypes.func,
    getItems: PropTypes.func,
    isPruned: PropTypes.bool,
    clearSelections: PropTypes.func,
    handlePlay: PropTypes.func,
  };

  section(
    {Node, type, title, subtitle, description, data, limit},
    extraProps = {},
    extraContent = null
  ) {
    return (
      <section className={classnames('cvrv', type)}>
        <div className="cvrv-container">
          <div className="cvrv-heading">
            <h2>{title}</h2>
            <h1>{subtitle}</h1>
            {description}
          </div>
          <div className="cvrv-content">
            {this.props.getItems(Node, type, data, limit, extraProps)}
          </div>
        </div>
        {extraContent}
      </section>
    );
  }

  render() {
    const {section, mobile, tablet, getMessage} = this.props;

    switch (section._type) {
      case 'Fortnite - Idomoo Heading': {
        return (
          <VideoRecapHeader
            data={section}
            mobile={mobile}
            tablet={tablet}
            getMessage={getMessage}
          />
        );
      }
      case 'Fortnite - Idomoo Scene List': {
        return this.section(
          {
            Node: VideoRecapScene,
            type: sectionType.SCENE,
            title: getMessage(`${i18nPrefix}.step1.title`),
            subtitle: getMessage(`${i18nPrefix}.step1.subtitle`),
            description: <p>{getMessage(`${i18nPrefix}.selectStats`)}</p>,
            data: section.data,
            limit: section.limit,
          },
          {},
          <button
            className="cvrv-btn diagonal inverted small divider"
            disabled={!this.props.isPruned}
            onClick={this.props.clearSelections}>
            {getMessage(`${i18nPrefix}.clearSelections`)}
          </button>
        );
      }
      case 'Fortnite - Idomoo Theme Color List': {
        return this.section({
          Node: VideoRecapTheme,
          type: sectionType.THEME,
          title: getMessage(`${i18nPrefix}.step2.title`),
          subtitle: getMessage(`${i18nPrefix}.step2.subtitle`),
          data: section.data,
          limit: section.limit,
        });
      }
      case 'Fortnite - Idomoo Soundtrack List': {
        return this.section(
          {
            Node: VideoRecapSoundtrack,
            type: sectionType.SOUNDTRACK,
            title: getMessage(`${i18nPrefix}.step3.title`),
            subtitle: getMessage(`${i18nPrefix}.step3.subtitle`),
            data: section.data,
            limit: section.limit,
          },
          {
            text: getMessage(`${i18nPrefix}.preview`),
            handlePlay: this.props.handlePlay,
          }
        );
      }
      default: {
        return <div />;
      }
    }
  }
}
